export function prepareSocialPostProps(ref) {
    if (!ref) return null;
    var author = ref.author || {};
    return {
        id: String(ref.id || ''),
        content: ref.content || '',
        author: {
            id: String(author.id || ''),
            name: author.name || author.username || '',
            username: author.username || '',
            profileImage: author.profileImage || author.avatar || '',
            verified: !!author.verified
        },
        createdAt: ref.createdAt || new Date(),
        images: ref.images || [],
        videos: ref.videos || []
    };
}
